import {
  Component, OnDestroy, OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: [ './breadcrumbs.component.scss' ],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  routerSubscription: any;
  permissionsSubscription: any;
  selectedUserSubscription: any;
  breadcrumbs: any;
  breadcrumbObjects: any;
  private permissions: any;
  private selectedUser: any;
  constructor( private router: Router, private authService: AuthService, private usersService: UsersService) { }

  ngOnInit() {
    this.permissionsSubscription = this.authService.permissions$
      .subscribe((userPermissions: any) => {
        this.permissions = userPermissions;
        this.buildBreadcrumbs();
      });

    this.selectedUserSubscription = this.usersService.selectedUserData$
      .subscribe((user: any) => {
        this.selectedUser = user;
        this.buildBreadcrumbs();
      });

    this.routerSubscription = this.router.events.subscribe(() => {
      this.buildBreadcrumbs();
    })
  }

  private buildBreadcrumbs() {
    if (!this.router.url) return;

    const path = this.router.url.split('?')[0];

    this.breadcrumbs = path
    // split url string into an array of capitalized de-hypenated words
      .split('/')
      .map((breadcrumb) => {
        return breadcrumb.replace('-', ' ').replace(/\b\w/g, (l) => l.toUpperCase());
      })
      // remove the first element (empty string)
      .slice(1);
    // this creates an array of objects that have the breadcrumb name and the url
    this.breadcrumbObjects = this.breadcrumbs.map((breadcrumb: any, index: any) => {
      return {
        name: breadcrumb,
        url: path.split('/').slice(0, index + 2).join('/'),
      };
    });
    // if the name of an object in the breadCrumbObjects is 'Manage Courses' change its url to 'manage-courses/index'
    this.breadcrumbObjects.forEach((breadcrumb: any) => {
      if (breadcrumb.name === 'Manage Courses') {
        breadcrumb.url = 'manage-courses/index';
      }
      if (breadcrumb.name === 'Bulk User-Update') {
        breadcrumb.name = 'Identity Sync';
      }
    });
    if (this.breadcrumbObjects[0].name === 'Bulletin Board') {
      if (this.breadcrumbObjects[1] && this.breadcrumbObjects[1].name !== 'New') {
        this.breadcrumbObjects[1].name = 'View Full Post'
      }
      if (this.breadcrumbObjects[1] && this.breadcrumbObjects[1].url == '/bulletin-board/new') {
        this.breadcrumbObjects[1].name = 'New Post'
      }
    }
    if (this.breadcrumbObjects[0]?.name === 'Profile' && this.breadcrumbObjects.length > 1 && this.authService.hasManageStaffPermission(this.permissions)) {
      this.breadcrumbObjects[0].name = 'Manage Staff';
      this.breadcrumbObjects[0].url = '/manage-staff';
      this.breadcrumbObjects[0].queryParams = { restoreFilters: '1' };
    }
    // Replace numeric user ID segment with user's name when viewing a profile
    if ((this.breadcrumbObjects[0]?.name === 'Profile' || this.breadcrumbObjects[0]?.name === 'Manage Staff') && this.breadcrumbObjects[1]) {
      const urlSegments = path.split('/');
      const urlIdSegment = urlSegments[2];
      if (urlIdSegment && /^\d+$/.test(urlIdSegment) && this.selectedUser && String(this.selectedUser.id) === urlIdSegment) {
        this.breadcrumbObjects[1].name = this.selectedUser.fullName || (this.selectedUser.firstName && this.selectedUser.lastName ? this.selectedUser.firstName + ' ' + this.selectedUser.lastName : urlIdSegment);
      }
    }
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
    this.permissionsSubscription?.unsubscribe();
    this.selectedUserSubscription?.unsubscribe();
  }

}
